import React, {
  ReactElement,
  Component,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
  useEffect,
  useCallback
} from 'react';
import {
  Progress,
  Table,
  Menu,
  Dropdown,
  Button,
  Badge,
  Row,
  Col,
  Descriptions,
  Empty,
  Typography,
  Tooltip,
  Pagination
} from 'antd';
import {injectIntl, FormattedMessage} from 'react-intl';
import {Link, withRouter} from "react-router-dom";
import {MoreOutlined, EditOutlined} from '@ant-design/icons';

// 变量
import {ModalVisibleContext} from "../contexts/modal-visible";
import {ListItemSelectedContext} from '../contexts/list-item-selected';
import {ContentSidebarSelectedContext} from '../contexts/content-sidebar-selected';
import {ModalDataContext} from "../contexts/modal-data";

// data type
import {modalType, modalDataType} from "../common-file/interfaceType";
import {getPopupNode, http_get} from "../common-file/service";
import {URLDataContext} from "../contexts/url-data";
import {IUserInfoType, UserInfoContext} from "../../../contexts/user-info";
import {ShowProtocolContext} from "../contexts/show-protocol";
import {Version} from '../../../app/enum/version.enum';

const status_data: any = {
  active: '#52c41a',
  enable: '#52c41a',
  running: '#52c41a',
  inprogress: '#faad14'
};

const disable_action: any = {
  inprogress: true,
  inactive: true
};

const TableList = (props: any): ReactElement<any, string | (new(props: any) => Component<any, any, any>)> => {

  const {intl, history, datasource, columns, action} = props,
    set_modal_visible: Dispatch<SetStateAction<modalType>> = useContext(ModalVisibleContext)[1],
    set_modal_data: Dispatch<SetStateAction<modalDataType>> = useContext(ModalDataContext)[1],
    set_list_item_selected: Dispatch<SetStateAction<object>> = useContext(ListItemSelectedContext)[1],
    content_sidebar_selected: string = useContext(ContentSidebarSelectedContext)[0],
    [table_sort_state, set_table_sort_state]: [any, Dispatch<SetStateAction<any>>] = useState({}),
    [local_sort_data, set_local_sort_data]: [any, Dispatch<SetStateAction<any>>] = useState(false),
    [descriptions_current, set_descriptions_current]: [number, Dispatch<SetStateAction<number>>] = useState(1),
    url_data: any = useContext(URLDataContext)[0],
    [pagination_list, set_pagination_list]: [any, Dispatch<SetStateAction<any>>] = useState(),
    user_info: IUserInfoType = useContext(UserInfoContext)[0],
    set_show_protocol: React.Dispatch<React.SetStateAction<boolean>> = useContext(ShowProtocolContext)[1];
  // const [columns_used, set_columns_used]: [any, Dispatch<SetStateAction<any>>] = useState([]);

  const sorterString = (a: any, b: any, key: string) => {
    const v1: string = (a[key] || '').toUpperCase(),
      v2: string = (b[key] || '').toUpperCase();
    return v1 < v2 ? -1 : v1 === v2 ? 0 : 1;
  };

  const sorterDate = (a: any, b: any, key: string) => {
    const date1: any = new Date(a[key]),
      date2: any = new Date(b[key]),
      v1: number = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate(), date1.getHours(), date1.getMinutes(), date1.getSeconds()),
      v2: number = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate(), date2.getHours(), date2.getMinutes(), date2.getSeconds());
    return v1 < v2 ? -1 : v1 === v2 ? 0 : 1;
  };

  const check_page = () => {
    let pathname: string = ',';
    switch (history.location.pathname) {
      case '/':
        pathname = 'serviceList';
        break;
      case '/service-list':
        pathname = 'serviceList';
        break;
      case '/create-secret':
        if (content_sidebar_selected === 'DCCS') {
          pathname = 'createDCCS';
        } else {
          pathname = 'createSecret';
        }
        break;
      case '/resource-management/overview':
        pathname = 'overview';
        break;
      case '/resource-management/service-management':
        pathname = 'service-management';
        break;
      default:
        break;
    }
    return pathname;
  };

  const init_local_sort = () => {
    const local_data: any = (JSON.parse(localStorage.getItem('local_sort') || '{}')[check_page()] || {});
    set_table_sort_state(local_data);
    set_local_sort_data(local_data);
  };

  useEffect(() => {
    (!local_sort_data) && init_local_sort();
    // eslint-disable-next-line
  }, [local_sort_data]);

  useEffect(() => {
    init_local_sort();
    // eslint-disable-next-line
  }, [content_sidebar_selected]);

  const upper_case_first = (str: string | undefined) => {
    switch (str) {
      case 'enable':
        return 'Enabled';
      case 'disable':
        return 'Disabled';
      case 'inprogress':
        return 'In Progress';
      case 'Inprogress':
        return 'In Progress';
      default:
        return str ? `${str.slice(0, 1).toUpperCase()}${str.slice(1)}` : str;
    }
  };

  // 表格的所有header
  const all_columns: any = {
    name: {
      title: intl.formatMessage({id: 'name'}),
      key: 'name_default',
      dataIndex: 'name_default',
      sorter: (a: any, b: any) => sorterString(a, b, 'name'),
      sortOrder: table_sort_state.name_default || ''
    },
    name_link: {
      title: intl.formatMessage({id: 'name'}),
      key: 'name_link',
      sorter: (a: any, b: any) => sorterString(a, b, 'name'),
      render: (list: any) => (
        // eslint-disable-next-line
        <a href="#">{list.name}</a>
      ),
      sortOrder: table_sort_state.name_link || ''
    },
    instance_name: {
      title: intl.formatMessage({id: 'instance_name'}),
      key: 'instance_name',
      // fixed: 'left',
      sorter: (a: any, b: any) => sorterString(a, b, 'instanceName'),
      render: (list: any) => (<div>{list.dashboard_url ?
        <Link
          to={'#'}
          onClick={() => list.dashboard_url && window.open(list.dashboard_url, '_blank')}
          className={'text-break-all'}
        >
          {list.instanceName}
        </Link> :
        <span className={'text-break-all'}>{list.instanceName}</span>}
        &nbsp;&nbsp;
        {list.instanceName && <Tooltip title={intl.formatMessage({id: 'rename'})}>
          <EditOutlined
            className={'blue-text cursor-pointer'}
            onClick={() => {
              set_modal_visible({toggle: true, type: 'rename'});
              item_selected(list);
            }}
          />
        </Tooltip>}
      </div>),
      sortOrder: table_sort_state.instance_name || ''
    },
    instance_id: {
      title: intl.formatMessage({id: 'instance_id'}),
      key: 'instanceId',
      sorter: (a: any, b: any) => sorterString(a, b, 'instanceId'),
      render: (list: any) => (
        <Typography.Paragraph copyable={{text: list.instanceId}}>{list.instanceId}</Typography.Paragraph>
      ),
      sortOrder: table_sort_state.instanceId || ''
    },
    secret_name: {
      title: intl.formatMessage({id: 'secret_name'}),
      key: 'name',
      dataIndex: 'name',
      fixed: 'left',
      sorter: (a: any, b: any) => sorterString(a, b, 'name'),
      sortOrder: table_sort_state.name || ''
    },
    dccs_name: {
      title: intl.formatMessage({id: 'dccs_name'}),
      key: 'dccs_name',
      fixed: 'left',
      sorter: (a: any, b: any) => sorterString(a, b, 'name'),
      render: (list: any) => (
        <Typography.Paragraph copyable={{text: list.name}}>
          <a
            href={url_data["api-dccs"] ?
              `${url_data["api-dccs"].externalUrl}/serviceCredentials/${list.dccsKey}` :
              `dccs/v1/serviceCredentials/${list.dccsKey}`
            }
            target={'_blank'}
            rel='noopener noreferrer'
          >
            {list.name}
          </a>
        </Typography.Paragraph>
      ),
      sortOrder: table_sort_state.dccs_name || ''
    },
    dataCenter: {
      title: intl.formatMessage({id: 'dataCenter'}),
      key: 'dataCenter',
      dataIndex: 'dataCenter',
      sorter: (a: any, b: any) => sorterString(a, b, 'dataCenter'),
      sortOrder: table_sort_state.dataCenter || ''
      // align: 'center'
    },
    description: {
      title: intl.formatMessage({id: 'description'}),
      key: 'description',
      dataIndex: 'description',
      sorter: (a: any, b: any) => sorterString(a, b, 'description'),
      sortOrder: table_sort_state.description || ''
      // align: 'center'
    },
    cluster: {
      title: intl.formatMessage({id: 'cluster'}),
      key: 'cluster',
      dataIndex: 'cluster',
      sorter: (a: any, b: any) => sorterString(a, b, 'cluster'),
      sortOrder: table_sort_state.cluster || ''
      // align: 'center'
    },
    workspace: {
      title: intl.formatMessage({id: 'workspace'}),
      key: 'workspace',
      dataIndex: 'workspace',
      sorter: (a: any, b: any) => sorterString(a, b, 'workspace'),
      sortOrder: table_sort_state.workspace || ''
      // align: 'center'
    },
    namespace: {
      title: intl.formatMessage({id: 'namespace'}),
      key: 'namespace',
      dataIndex: 'namespace',
      sorter: (a: any, b: any) => sorterString(a, b, 'namespace'),
      sortOrder: table_sort_state.namespace || ''
      // align: 'center'
    },
    create_time: {
      title: intl.formatMessage({id: 'create_time'}),
      key: 'createTime',
      dataIndex: 'createTime',
      // align: 'center',
      sorter: (a: any, b: any) => sorterDate(a, b, 'createTime'),
      sortOrder: table_sort_state.createTime || ''
    },
    plan: {
      title: intl.formatMessage({id: 'plan_sp'}),
      key: 'plan',
      dataIndex: 'plan',
      sorter: (a: any, b: any) => sorterString(a, b, 'plan'),
      sortOrder: table_sort_state.plan || ''
      // align: 'center'
    },
    capacity: {
      title: intl.formatMessage({id: 'capacity'}),
      key: 'capacity',
      sorter: (a: any, b: any) => a.capacity.used - b.capacity.used,
      render: (list: any) => (
        <div>
          <div>{`${list.capacity.used}MB/${list.capacity.total}MB`}</div>
          <div>
            <Progress
              percent={list.capacity.used / list.capacity.total * 100} showInfo={false}
              strokeColor={list.capacity.used / list.capacity.total >= 0.9 ? '#f5222d' : '#108ee9'}
            />
          </div>
        </div>
      ),
      sortOrder: table_sort_state.capacity || ''
    },
    status: {
      title: intl.formatMessage({id: 'status'}),
      key: 'status',
      fixed: 'left',
      width: 110,
      align: 'center',
      sorter: (a: any, b: any) => sorterString(a, b, 'status'),
      render: (list: any) => (<Badge count={upper_case_first(list.status)} style={{
        background: status_data[list.status.toLowerCase()] || '#f5222d',
        borderRadius: '4px',
        minWidth: '60px',
        lineHeight: 1.5
      }}/>),
      sortOrder: table_sort_state.status || ''
    },
    type: {
      title: intl.formatMessage({id: 'type'}),
      key: 'type',
      dataIndex: 'type',
      sorter: (a: any, b: any) => sorterString(a, b, 'type'),
      sortOrder: table_sort_state.type || ''
      // align: 'center'
    },
    series: {
      title: intl.formatMessage({id: 'series'}),
      key: 'series',
      dataIndex: 'series',
      sorter: (a: any, b: any) => sorterString(a, b, 'series'),
      sortOrder: table_sort_state.series || ''
      // align: 'center'
    },
    time_since_create: {
      title: intl.formatMessage({id: 'time_since_create'}),
      key: 'timeSinceCreate',
      dataIndex: 'timeSinceCreate',
      // align: 'center'
    },
    service_name: {
      title: intl.formatMessage({id: 'service_name'}),
      key: 'service',
      dataIndex: 'service',
      sorter: (a: any, b: any) => sorterString(a, b, 'service'),
      sortOrder: table_sort_state.service || ''
      // align: 'center'
    },
    pseudo_id: {
      title: intl.formatMessage({id: 'pseudo_id'}),
      fixed: 'left',
      key: 'pseudoID',
      render: (list: any) => (
        <Typography.Paragraph copyable={{text: list.pseudoID}}>{list.pseudoID}</Typography.Paragraph>
      ),
      sorter: (a: any, b: any) => sorterString(a, b, 'pseudoID'),
      sortOrder: table_sort_state.pseudoID || ''
    },
    deployment_name: {
      title: intl.formatMessage({id: 'deployment_name'}),
      key: 'deploymentName',
      render: (list: any) => (
        <Typography.Paragraph copyable={{text: list.deploymentName}}>{list.deploymentName}</Typography.Paragraph>
      ),
      sorter: (a: any, b: any) => sorterString(a, b, 'deploymentName'),
      sortOrder: table_sort_state.deploymentName || ''
    },
    subscription_name: {
      title: intl.formatMessage({id: 'subscription_name'}),
      key: 'subscriptionName',
      dataIndex: 'subscriptionName',
      sorter: (a: any, b: any) => sorterString(a, b, 'subscriptionName'),
      sortOrder: table_sort_state.subscriptionName || ''
    },
    company: {
      title: intl.formatMessage({id: 'company'}),
      key: 'company',
      dataIndex: 'company',
      sorter: (a: any, b: any) => sorterString(a, b, 'company'),
      sortOrder: table_sort_state.company || ''
    },
    quota: {
      title: intl.formatMessage({id: 'quota'}),
      key: 'quota',
      dataIndex: 'quota',
      sorter: (a: any, b: any) => a.quota - b.quota,
      sortOrder: table_sort_state.quota || ''
    },
    remain: {
      title: intl.formatMessage({id: 'remain'}),
      key: 'remain',
      dataIndex: 'remain',
      sorter: (a: any, b: any) => a.remain - b.remain,
      sortOrder: table_sort_state.remain || ''
    },
    running: {
      title: intl.formatMessage({id: 'running'}),
      key: 'running',
      dataIndex: 'running',
      sorter: (a: any, b: any) => a.running - b.running,
      sortOrder: table_sort_state.running || ''
    },
    detached: {
      title: intl.formatMessage({id: 'detached'}),
      key: 'detached',
      dataIndex: 'detached',
      sorter: (a: any, b: any) => a.detached - b.detached,
      sortOrder: table_sort_state.detached || ''
    },
    broker_url: {
      title: intl.formatMessage({id: 'broker_url'}),
      key: 'brokerUrl',
      render: (list: any) => (
        <Typography.Paragraph copyable={{text: list.brokerUrl}}>{list.brokerUrl}</Typography.Paragraph>),
      sorter: (a: any, b: any) => sorterString(a, b, 'brokerUrl'),
      sortOrder: table_sort_state.brokerUrl || ''
    },
    broker_service_id: {
      title: intl.formatMessage({id: 'broker_service_id'}),
      key: 'brokerServiceId',
      dataIndex: 'brokerServiceId',
      sorter: (a: any, b: any) => sorterString(a, b, 'brokerServiceId'),
      sortOrder: table_sort_state.brokerServiceId || ''
    },
    broker_plan_id: {
      title: intl.formatMessage({id: 'broker_plan_id'}),
      key: 'brokerPlanId',
      dataIndex: 'brokerPlanId',
      sorter: (a: any, b: any) => sorterString(a, b, 'brokerPlanId'),
      sortOrder: table_sort_state.brokerPlanId || ''
    },
    bindable: {
      title: intl.formatMessage({id: 'broker_bindable'}),
      key: 'bindable',
      dataIndex: 'bindable',
      width: '100px',
      sorter: (a: any, b: any) => sorterString(a, b, 'bindable'),
      sortOrder: table_sort_state.bindable || ''
    },
  };

  const action_type = (service_name: string | undefined, plan: string | undefined) => {
      switch (service_name) {
        case 'MongoDB':
          return plan !== 'Shared';
        case 'PostgreSQL':
          return plan !== 'Shared';
        case 'InfluxDB':
          return true;
        default:
          return false;
      }
    },
    confirm_accept = useCallback(async () => {
      const session_back: any = JSON.parse(sessionStorage.getItem('accept_backup') || '{}');
       if(session_back?.cookieInfo?.backup === 'accept'){
         return true
       }else {
         const submit_res: any = await http_get(`/serviceHub/v2/user/${user_info.id}/info`, props);
         if (submit_res?.data?.cookieInfo?.backup === "accept") {
           sessionStorage.setItem("accept_backup", JSON.stringify(submit_res?.data));
           return true
         } else {
           return false
         }
       }
      // eslint-disable-next-line
    }, [user_info.id]),
    all_actions = (item: any) => {
      const {service, plan, status, enable, user_provided} = item;
      const all_action = action && <Menu style={{textAlign: 'center'}}>
        {/*服务管理*/}
        {action.service_management && <Menu.Item key={'service_management'}>
          <FormattedMessage id={'service_management'}/>
        </Menu.Item>}
        {/*密钥管理*/}
        {action.secret_management && <Menu.Item
          key={'secret_management'}
          disabled={!(item.bindable === 'true')}
          onClick={() => history.push('/create-secret')}
        >
          <FormattedMessage id={'secret_management'}/>
        </Menu.Item>}
        {/*取消订阅*/}
        {action.cancel_subscribe && <Menu.Item
          key={'cancel_subscribe'}
          onClick={() => set_modal_visible({
              toggle: true,
              type: 'cancel'
            }
          )}>
          <FormattedMessage id={'cancel_subscribe'}/>
        </Menu.Item>}
        {/*新建*/}
        {action.create &&
        <Menu.Item key={'create'} onClick={() => set_modal_visible({toggle: true, type: 'create'})}>
          <FormattedMessage id={'create'}/>
        </Menu.Item>}
        {/*查看*/}
        {action.view &&
        <Menu.Item key={'view'} onClick={() => set_modal_visible({toggle: true, type: 'view'})}>
          <FormattedMessage id={'view'}/>
        </Menu.Item>}
        {/*重建*/}
        {action.recreate &&
        <Menu.Item key={'recreate'} onClick={() => set_modal_visible({toggle: true, type: 'recreate'})}>
          <FormattedMessage id={'recreate'}/>
        </Menu.Item>}
        {/*查看资源*/}
        {action.view_resource && <Menu.Item key={'view_resource'}>
          <FormattedMessage id={'view_resource'}/>
        </Menu.Item>}
        {/*编辑*/}
        {(action?.edit === 'instance'? (user_info?.ssoRole === 'globalAdmin' && action_type(service, plan) && status?.toLowerCase() !== 'inactive'): action.edit) &&
        <Menu.Item key={'edit'} onClick={() => {
          if(action?.edit === 'instance'){
            set_modal_data({
              title: 'edit_instance',
              type: 'edit'
            });
          }
          set_modal_visible({toggle: true, type: 'edit'})
        }}>
          <FormattedMessage id={'edit'}/>
        </Menu.Item>}
        {/*备份还原*/}
        {/*{action.backup_restore && action_type(service, plan) && <Menu.Item*/}
        {action.backup_restore && (Version.mp_cloud as any === 'true'? user_info?.ssoRole === 'globalAdmin': true) && action_type(service, plan) && user_provided === "false" && <Menu.Item
          key={'backup_restore'}
          disabled={!(item.bindable === 'true')}
          onClick={async () => {
            if (await confirm_accept()) {
              history.push('/service-backup-restore');
            } else {
              set_show_protocol(true)
            }
          }}
        >
          <FormattedMessage id={'backup_restore'}/>
        </Menu.Item>}
        {/*启用*/}
        {action.start &&
        <Menu.Item key={'start'} onClick={() => set_modal_visible({toggle: true, type: 'start'})}>
          <FormattedMessage id={'start'}/>
        </Menu.Item>}
        {/*停用*/}
        {action.enable && (enable === 'enable') &&
        <Menu.Item key={'disable'} onClick={() => set_modal_visible({toggle: true, type: 'disable'})}>
          <FormattedMessage id={'disable_1'}/>
        </Menu.Item>}
        {/*启用*/}
        {action.enable && (enable === 'disable') &&
        <Menu.Item key={'enable'} onClick={() => set_modal_visible({toggle: true, type: 'enable'})}>
          <FormattedMessage id={'enable'}/>
        </Menu.Item>}
        {/*更新*/}
        {action.update &&
        <Menu.Item key={'update'} onClick={() => set_modal_visible({toggle: true, type: 'update'})}>
          <FormattedMessage id={'update'}/>
        </Menu.Item>}
        {/*删除*/}
        {action.delete &&
        <Menu.Item key={'delete'} onClick={() => set_modal_visible({toggle: true, type: 'delete'})}>
          <FormattedMessage id={'delete'}/>
        </Menu.Item>}
        {action.monitoring &&
        <Menu.Item key={'monitoring'} onClick={() => set_modal_visible({toggle: true, type: 'monitoring'})}>
          <FormattedMessage id={'monitoring'}/>
        </Menu.Item>}
        {action.detach_cluster &&
        <Menu.Item key={'detach_cluster'} onClick={() => set_modal_visible({toggle: true, type: 'detach_cluster'})}>
          <FormattedMessage id={'detach_cluster'}/>
        </Menu.Item>}
        {action.resume_cluster &&
        <Menu.Item key={'resume_cluster'} onClick={() => set_modal_visible({toggle: true, type: 'resume_cluster'})}>
          <FormattedMessage id={'resume_cluster'}/>
        </Menu.Item>}
        {action.delete_cluster &&
        <Menu.Item key={'delete_cluster'} onClick={() => set_modal_visible({toggle: true, type: 'delete_cluster'})}>
          <FormattedMessage id={'delete_cluster'}/>
        </Menu.Item>}
      </Menu>;
      return <Dropdown
        overlay={all_action}
        trigger={['click']}
        placement={'bottomCenter'}
        getPopupContainer={() => getPopupNode()}
        disabled={disable_action[status?.toLowerCase()]}
      >
        <Button className="plain_button" onClick={() => {
          item_selected(item)
        }}>
          <MoreOutlined/>
        </Button>
      </Dropdown>
    };

  // useEffect(() => {
  //     if (columns) {
  //         let new_col = [];
  //         // eslint-disable-next-line
  //         columns.map((key: string) => {
  //             new_col.push(all_columns[key])
  //         });
  //         Object.keys(action).length > 0 && new_col.push({
  //             title: intl.formatMessage({id: 'action'}),
  //             width: '100px',
  //             key: 'action',
  //             fixed: 'right',
  //             render: (item: any) => all_actions(item)
  //         });
  //         set_columns_used(new_col);
  //     }
  //     // eslint-disable-next-line
  // }, [columns]);

  const columns_used: any = () => {
    let new_col = [];
    // eslint-disable-next-line
    columns.map((key: string) => {
      new_col.push(all_columns[key])
    });
    Object.keys(action).length > 0 && new_col.push({
      title: intl.formatMessage({id: 'action'}),
      width: '100px',
      key: 'action',
      fixed: 'right',
      render: (item: any) => all_actions(item)
    });
    return new_col
  };

  // const item_selected = (item: any) => {
  //     set_list_item_selected(item);
  //     let session_key: string| undefined = undefined;
  //     switch (history.location.pathname) {
  //         case '/':
  //             session_key = 'instance_list_item_selected';
  //             break;
  //         case '/service-list':
  //             session_key = 'instance_list_item_selected';
  //             sessionStorage.removeItem('content_sidebar_selected');
  //             break;
  //         case '/create-secret':
  //             session_key = 'secret_list_item_selected';
  //             break;
  //         case '/resource-management/overview':
  //             session_key = 'overview_list_item_selected';
  //             break;
  //         case '/resource-management/service-management':
  //             session_key = 'service_management_item_selected';
  //             break;
  //         default:
  //             break;
  //     }
  //     session_key && sessionStorage.setItem(session_key, JSON.stringify(item));
  // };

  const item_selected = (item: any) => {
    set_list_item_selected(item);
    switch (history.location.pathname) {
      case '/instance-list':
        sessionStorage.setItem('instance_list_item_selected', JSON.stringify(item));
        sessionStorage.removeItem('content_sidebar_selected');
        break;
      case '/create-secret':
        sessionStorage.setItem('secret_list_item_selected', JSON.stringify(item));
        break;
      case '/resource/view':
        sessionStorage.setItem('overview_list_item_selected', JSON.stringify(item));
        break;
      case '/resource/service':
        sessionStorage.setItem('service_management_item_selected', JSON.stringify(item));
        break;
      default:
        break;
    }
  };

  const description_item = (item: any, val: string) => {
    let returnVal: any;
    switch (val) {
      case 'name':
        returnVal = item.name;
        break;
      case 'secret_name':
        returnVal = item.name;
        break;
      case 'dataCenter':
        returnVal = item.dataCenter;
        break;
      case 'cluster':
        returnVal = item.cluster;
        break;
      case 'workspace':
        returnVal = item.workspace;
        break;
      case 'namespace':
        returnVal = item.namespace;
        break;
      case 'description':
        returnVal = item.description;
        break;
      case 'create_time':
        returnVal = item.createTime;
        break;
      case 'plan':
        returnVal = item.plan;
        break;
      case 'type':
        returnVal = item.type;
        break;
      case 'series':
        returnVal = item.series;
        break;
      case 'time_since_create':
        returnVal = item.timeSinceCreate;
        break;
      case 'service_name':
        returnVal = item.service;
        break;
      case 'subscription_name':
        returnVal = item.subscriptionName;
        break;
      case 'company':
        returnVal = item.company;
        break;
      case 'quota':
        returnVal = item.quota;
        break;
      case 'remain':
        returnVal = item.remain;
        break;
      case 'running':
        returnVal = item.running;
        break;
      case 'detached':
        returnVal = item.detached;
        break;
      case 'broker_url':
        returnVal = <Typography.Paragraph copyable={{text: item.brokerUrl}}>{item.brokerUrl}</Typography.Paragraph>;
        break;
      case 'broker_service_id':
        returnVal = item.brokerServiceId;
        break;
      case 'broker_plan_id':
        returnVal = item.brokerPlanId;
        break;
      case 'bindable':
        returnVal = item.bindable;
        break;
      case 'name_link':
        returnVal = <Link to={'#'}>{item.name}</Link>;
        break;
      case 'instance_name':
        returnVal = (<div>{item.dashboard_url ?
          <Link className={'text-break-all'} to={'#'} onClick={() => {
            item.dashboard_url && window.open(item.dashboard_url, '_blank')
          }}>{item.instanceName}</Link> :
          <span className={'text-break-all font-weight-bold'}>{item.instanceName}</span>}
          &nbsp;&nbsp;
          {item.instanceName && <Tooltip title={intl.formatMessage({id: 'rename'})}>
            <EditOutlined
              className={'blue-text cursor-pointer'}
              onClick={() => {
                set_modal_visible({toggle: true, type: 'rename'});
                item_selected(item);
              }}
            />
          </Tooltip>}
        </div>);
        break;
      case 'status':
        returnVal = <Badge count={upper_case_first(item.status)} style={{
          background: status_data[item.status.toLowerCase()] || '#f5222d',
          borderRadius: '4px',
          minWidth: '60px',
          lineHeight: 1.5
        }}/>;
        break;
      case 'dccs_name':
        returnVal = (
          <Typography.Paragraph copyable={{text: item.name}}>
            <a
              href={url_data["api-dccs"] ?
                `${url_data["api-dccs"].externalUrl}/serviceCredentials/${item.dccsKey}` :
                `dccs/v1/serviceCredentials/${item.dccsKey}`
              }
              target={'_blank'}
              rel='noopener noreferrer'
            >
              {item.name}
            </a>
          </Typography.Paragraph>
        );
        break;
      case 'instance_id':
        returnVal = (
          <Typography.Paragraph copyable={{text: item.instanceId}}>{item.instanceId}</Typography.Paragraph>
        );
        break;
      case 'pseudo_id':
        returnVal = (
          <Typography.Paragraph copyable={{text: item.pseudoID}}>{item.pseudoID}</Typography.Paragraph>
        );
        break;
      default:
        returnVal = '';
        break;
    }
    return returnVal;
  };

  const description_span: any = {
    instance_name: 2,
    dccs_name: 2,
    instance_id: 2,
    secret_name: 3
  };

  const table_sort_change = (sort: any) => {
    let local_sort: {} = JSON.parse(localStorage.getItem('local_sort') || '{}');
    let table_sort: any = {}, page_sort: any = {};
    table_sort[sort.columnKey] = sort.order;
    set_table_sort_state(table_sort);
    page_sort[check_page()] = table_sort;
    localStorage.setItem('local_sort', JSON.stringify({...local_sort, ...page_sort}));
  };

  useEffect(() => {
    if (datasource && datasource.length) {
      const pageSize: number = Number(localStorage.getItem('default_page_size')) || 10;
      set_pagination_list(datasource.slice(0, pageSize));
      set_descriptions_current(1);
    }
    // eslint-disable-next-line
  }, [datasource]);

  const pagination_change = (page: number) => {
    set_descriptions_current(page);
    const pageSize: number = Number(localStorage.getItem('default_page_size')) || 10,
      list_index: number = (page - 1) * 5;
    set_pagination_list(datasource.slice(list_index, list_index + pageSize));
  };

  return (
    <div>{datasource && datasource.length >= 0 ?
      <Row className="management-table w-100">
        <Col xs={0} sm={0} md={24}>
          <Table
            size="small"
            dataSource={datasource}
            columns={columns_used()}
            pagination={{
              defaultPageSize: Number(localStorage.getItem('default_page_size')) || 10,
              hideOnSinglePage: datasource.length <= 5,
              showSizeChanger: true,
              pageSizeOptions: ['5', '10', '20', '50', '100']
            }}
            {...(datasource?.length> 0? {x: 1200}:{})}
            onChange={(pagination: any, filter: any, sort: any) => {
              localStorage.setItem('default_page_size', pagination.pageSize);
              table_sort_change(sort)
            }}
          />
        </Col>
        <Col xs={24} sm={24} md={0}>{
          pagination_list && pagination_list.map((item: any, key: number) => (
            <Descriptions
              key={key}
              layout={'vertical'}
              bordered
              column={{sm: 3, xs: 2}}
              size={'small'}
            >
              {columns.length > 0 && columns.map((val: string) => (
                <Descriptions.Item key={val} label={intl.formatMessage({id: val})} span={description_span[val] || 1}>
                  {description_item(item, val)}
                </Descriptions.Item>
              ))}
              {action && <Descriptions.Item key={'action'} label={intl.formatMessage({id: 'action'})}>
                {all_actions(item)}
              </Descriptions.Item>}
            </Descriptions>
          ))
        }</Col>
        <Col xs={24} sm={24} md={0}>
          <Pagination
            total={datasource.length}
            defaultPageSize={Number(localStorage.getItem('default_page_size')) || 10}
            hideOnSinglePage={datasource.length <= 5}
            showSizeChanger={true}
            pageSizeOptions={['5', '10', '20', '50', '100']}
            onChange={(pagination: number) => pagination_change(pagination)}
            size={'small'}
            current={descriptions_current}
          />
        </Col>
      </Row> :
      <Empty/>
    }</div>
  )
};

export default injectIntl(withRouter(TableList) as any);

